function parseTerrain(terrain) {
    var rows = terrain.split("\n");
    var meta = {
        info: {},
        data: [],
        max: undefined,
        min: undefined,
        mid: undefined
    }


    var parseMetas = true;
    for (var n = 0; n < rows.length; n++) {
        var row = rows[n];
        if (parseMetas) {
            if (row[0] == ' ' || row[0] == '-' || !isNaN(parseInt(row[0]))) {
                parseMetas = false;
            } else {
                var parts = row.match(/\S+/g); //row.split(' ');
                meta.info[parts[0].toUpperCase()] = parts.slice(1);
                if (parts[0] == 'NODATA_VALUE') {
                    meta.nodata_value = Number(meta.info[parts[0]][0]);
                }
                continue;
            }
        }

        if (row.length < 2) {
            console.log("#", n, row);
            continue;
        }


        var parts = row.match(/\S+/g); //.split(' ');
        for (var p = 0; p < parts.length; p++) {
            if (parts[p] === undefined || parts[p].length == 0) {
                console.log("ROW", n, "COL", p, parts[p]);
                continue;
            }
            var pp = parts[p] = Number(parts[p]);
            if (meta.nodata_value && pp == meta.nodata_value) {
                pp = parts[p] = -20;
            } else {

                if (meta.max == undefined || pp > meta.max) {
                    meta.max = pp;
                }
                if (meta.min == undefined || pp < meta.min) {
                    meta.min = pp;
                }
            }
        }
        meta.data.push(parts);

    }
    meta.mid = meta.min + (meta.max - meta.min) / 2;
    return meta;
}



function loadTerrain(file, callback) {
    var req = new XMLHttpRequest();
    req.open('GET', file, true);
    req.onload = function (evt) {
        if (req.response) {

            var terrain = parseTerrain(req.response);

            callback(terrain);
        }
    };
    req.send(null);
}

export {
    loadTerrain,
    parseTerrain
}